import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationNext } from "@breuni-ui/carousel";

class KombiModulCarouselNavigationNext extends CarouselNavigationNext {}
safeDefine(
  "reco-kombi-modul-carousel-navigation-next",
  KombiModulCarouselNavigationNext,
);
